$(function() {
  var $dropdowns = $('.js-dropdown');

  $dropdowns.each(function (index, element) {

    //
    var $dropdown = $(element);
    var $dropdownControl = $dropdown.find('.js-dropdown-control');
    var $dropdownPopover = $dropdown.find('.js-dropdown-popover');
    var isExpanded = false;


    // Functions

    var handleFocusOut = function (e) {
      if (e.relatedTarget && !$dropdownPopover[0].contains(e.relatedTarget) && !$dropdownControl[0].contains(e.relatedTarget)) {
        close(false);
      }
    }

    var handleKeydown = function (e) {
      // Close on escape
      if (isExpanded && e.keyCode === 27) {
        close();
      }
    }

    var handleOutsideClick = function (e) {
      if (!$dropdownPopover[0].contains(e.target) && !$dropdownControl[0].contains(e.target)) {
        close(false);
      }
    }

    var open = function () {
      $dropdownControl.attr('aria-expanded', "true");
      $dropdownPopover.prop('hidden', false);
      isExpanded = true;

      $(document).on('click', handleOutsideClick);
      $(document).on('focusout', handleFocusOut);
    }

    var close = function (refocus) {
      var refocus = typeof refocus !== "undefined" ? refocus : true;
      $dropdownControl.attr('aria-expanded', "false");
      $dropdownPopover.prop('hidden', true);
      isExpanded = false;

      $(document).off('click', handleOutsideClick);
      $(document).off('focusout', handleFocusOut);

      if (refocus) {
        $dropdownControl.focus();
      }
    }

    var toggle = function() {
      isExpanded ? close() : open();
    }


    // Initialisation
    $dropdownPopover.attr('aria-labelledby', $dropdownControl.attr('id'));
    $dropdownPopover.prop('hidden', true);
    $dropdownControl.attr('aria-haspopup', "true");
    $dropdownControl.attr('aria-expanded', "false");
    $dropdownControl.attr('aria-controls', $dropdownPopover.attr('id'));

    // Listeners
    $dropdownControl.on('click', toggle);
    $dropdown.on('keydown', handleKeydown);

    $dropdown.addClass('is-mounted');
  });
});
